import React, { useState } from 'react';
import { ChevronDown, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-24 bg-dark">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary-light text-sm font-bold uppercase tracking-[0.2em]">{t.faq.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
            {t.faq.title}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
              {t.faq.titleGrad}
            </span>
          </h2>
          <p className="mt-4 text-slate-400">{t.faq.intro}</p>
        </div>

        <div className="space-y-3">
          {t.faq.items.map((faq, index) => (
            <div
              key={faq.q}
              className="border border-border-dark rounded-xl overflow-hidden transition-all hover:border-primary/25"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left bg-card-dark hover:bg-card-dark/90 transition-colors gap-4"
              >
                <span className="text-base font-semibold text-white">{faq.q}</span>
                <ChevronDown
                  className={`w-5 h-5 text-primary-light shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-dark border-t border-border-dark">
                  <p className="text-slate-400 leading-relaxed text-sm">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div id="kontakt" className="mt-16 bg-card-dark border border-border-dark rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-white mb-2">{t.faq.contactTitle}</h3>
          <p className="text-slate-400 mb-6 text-sm">{t.faq.contactLead}</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href={`mailto:${t.faq.email}`}
              className="flex items-center justify-center gap-2 bg-primary/10 border border-primary/30 hover:border-primary/60 text-primary-light px-6 py-3 rounded-xl text-sm font-semibold transition-all"
            >
              <Mail className="w-4 h-4" />
              {t.faq.email}
            </a>
            <a
              href="/s"
              className="flex items-center justify-center gap-2 bg-accent/10 border border-accent/25 hover:border-accent/50 text-accent px-6 py-3 rounded-xl text-sm font-semibold transition-all"
            >
              {t.headerCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
